export const getConfidencePresentation = (value) => {
  const confidence = Number(value)
  if (!Number.isFinite(confidence)) {
    return {
      label: 'Důvěra neurčena',
      percent: null,
      badgeClassName: 'bg-gray-100 text-gray-700',
      barClassName: 'bg-gray-400',
    }
  }

  const percent = Math.max(0, Math.min(100, Math.round(confidence * 100)))
  if (percent >= 70) {
    return {
      label: 'Vysoká důvěra',
      percent,
      badgeClassName: 'bg-emerald-100 text-emerald-800',
      barClassName: 'bg-emerald-600',
    }
  }

  if (percent >= 45) {
    return {
      label: 'Střední důvěra',
      percent,
      badgeClassName: 'bg-amber-100 text-amber-800',
      barClassName: 'bg-amber-500',
    }
  }

  return {
    label: 'Nižší důvěra',
    percent,
    badgeClassName: 'bg-rose-100 text-rose-800',
    barClassName: 'bg-rose-500',
  }
}

export const getSameConditionCount = (value, conditionTargets = []) => {
  const serializedCount = Number(value?.sameConditionComparablesCount)
  if (Number.isFinite(serializedCount)) return Math.max(0, serializedCount)

  const targets = conditionTargets.filter(Boolean)
  if (!targets.length) return 0
  return (value?.comparables || []).filter((comparable) => targets.includes(comparable.condition)).length
}
